<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editData" ref="editDataRef" label-width="110px">
          <el-form-item label="产品分类">
            <el-select v-model="editData.categories" placeholder="请选择" class="select">
              <el-option
                v-for="item in categoriesList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品名称" class="addAdminForm">
            <el-input v-model="editData.name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="产品简介" class="addAdminForm">
            <el-input v-model="editData.introduction" type="textarea" :rows="5" placeholder="请输入产品简介"></el-input>
          </el-form-item>
          <el-form-item label="产品价格" class="addAdminForm">
            <el-input v-model="editData.price" placeholder="请输入产品价格"></el-input>
          </el-form-item>
          <el-form-item label="明星产品缩略图" class="addAdminForm">
            <el-input v-model="editData.thumbnail1" placeholder="用于明星产品显示"></el-input>
          </el-form-item>
          <el-form-item label="通用产品缩略图" class="addAdminForm">
            <el-input v-model="editData.thumbnail2" placeholder="用于通用产品显示"></el-input>
          </el-form-item>
          <el-form-item label="产品详情图" class="addAdminForm">
            <el-input v-model="editData.details" placeholder="产品详情图片"></el-input>
          </el-form-item>
          <el-form-item label="是否明星产品">
            <el-select v-model="editData.isstar" placeholder="请选择" class="select">
              <el-option
                v-for="item in isStarList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否爆款推荐">
            <el-select v-model="editData.isrecommended" placeholder="请选择" class="select">
              <el-option
                v-for="item in isRecommendedList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="是否畅销产品">
            <el-select v-model="editData.isbest" placeholder="请选择" class="select">
              <el-option
                v-for="item in isList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
<!--          <el-form-item label="是否首页首推">
            <el-select v-model="editData.isfirst" placeholder="请选择" class="select">
              <el-option
                v-for="item in isFirstList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="排序" class="addAdminForm">
            <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      categoriesList: [
        { value: '', label: '请选择产品分类' },
        { value: '智能变焦镜', label: '智能变焦镜' },
        { value: '护眼台灯', label: '护眼台灯' },
        { value: '护眼产品', label: '护眼产品' }
      ],
      isStarList: [
        { value: '1', label: '左上' },
        { value: '2', label: '左下' },
        { value: '3', label: '中间' },
        { value: '4', label: '右上' },
        { value: '5', label: '右下' },
        { value: '0', label: '不是明星产品' }
      ],
      isRecommendedList: [
        { value: '1', label: '爆款1' },
        { value: '2', label: '爆款2' },
        { value: '3', label: '爆款3' },
        { value: '4', label: '爆款4' },
        { value: '5', label: '爆款5' },
        { value: '6', label: '爆款6' },
        { value: '7', label: '爆款7' },
        { value: '0', label: '不是爆款推荐' }
      ],
      isList: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      isFirstList: [
        { value: '1', label: '首推' },
        { value: '2', label: '次推' },
        { value: '0', label: '否' }
      ],
      editData: {
        id: '0',
        categories: '智能变焦镜',
        name: '',
        introduction: '',
        price: '',
        thumbnail1: '',
        thumbnail2: '',
        freedelivery: '',
        details: '',
        isstar: '0',
        isrecommended: '0',
        isbest: '0',
        isfirst: '0',
        listorder: '0'
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.categories = row.Categories
      this.editData.name = row.Name
      this.editData.introduction = row.Introduction
      this.editData.price = row.Price
      this.editData.thumbnail1 = row.Thumbnail1
      this.editData.thumbnail2 = row.Thumbnail2
      this.editData.freedelivery = row.Freedelivery
      this.editData.details = row.Details
      this.editData.isstar = row.Isstar.toString()
      this.editData.isrecommended = row.Isrecommended.toString()
      this.editData.isbest = row.Isbest.toString()
      this.editData.isfirst = row.Isfirst.toString()
      this.editData.listorder = row.Listorder
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteErpProduct()
    },
    EditKgjtWebsiteErpProduct: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        categories: that.editData.categories,
        name: that.editData.name,
        introduction: that.editData.introduction,
        price: that.editData.price,
        thumbnail1: that.editData.thumbnail1,
        thumbnail2: that.editData.thumbnail2,
        freedelivery: that.editData.freedelivery,
        details: that.editData.details,
        isstar: that.editData.isstar,
        isrecommended: that.editData.isrecommended,
        isbest: that.editData.isbest,
        isfirst: that.editData.isfirst,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteErpProduct, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
